var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1.13448cm",
    height: "1.14184cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 154.55 155.56",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M23.57 63.74c-0.01,-4.72 -0.58,-3.76 4.35,-3.75l18.92 0.1 0.04 69.99c-6.39,0 -16.81,0.25 -23.28,-0.12l-0.04 -66.21zm61.46 3.46c0.79,-0.9 1.16,-1.47 1.91,-2.23 10.14,-10.21 30.74,-8.86 39.13,4.94 4.94,8.12 4.76,16.31 4.79,27.68 0.02,8.35 0.33,25.11 -0.05,32.49l-23.11 -0.01c-0.41,-7.89 -0.04,-24.16 -0.05,-33.03 -0.01,-5.17 0.19,-10.14 -1.96,-14.47 -4.06,-8.16 -15.72,-7.76 -20.64,0.31 -2.61,4.28 -1.97,8.81 -1.95,14.44 0.03,5.48 0.04,11.03 -0.02,16.51 -0.05,5.22 0.31,11.11 -0.08,16.26l-23.12 -0.1c-0.48,-5.03 -0.01,-12.25 -0.02,-17.53l0.05 -44.03c-0,-1.1 -0.52,-7.72 0.31,-8.28 0.42,-0.29 14.76,-0.17 17.24,-0.14 0.88,0.01 4.85,-0.31 5.41,0.29 0.82,1.16 0.14,7.34 0.32,9.33l1.85 -2.43zm-52.44 -40.71c17.83,-3.27 21.55,20.65 5.71,23.66 -18.11,3.44 -22.17,-20.64 -5.71,-23.66zm-22.86 -26.17c-5,0.83 -8.96,4.63 -9.52,9.82 -0.3,2.73 -0.07,55.98 -0.07,58.02 -0,5.82 -0.34,73.41 0.09,77.27 0.57,5.12 4.57,8.98 9.43,9.78 3.62,0.6 51.53,0.15 57.89,0.18 12.93,0.06 25.87,-0.07 38.8,0.01 6.42,0.04 12.85,-0.04 19.26,-0 4.8,0.02 15.24,0.53 19.34,-0.2 4.82,-0.86 8.81,-4.81 9.34,-9.81l0.08 -115.75c-0,-5.89 0.45,-13.83 -0.07,-19.47 -0.44,-4.88 -4.39,-8.95 -9.32,-9.81 -3.7,-0.65 -51.72,-0.17 -57.91,-0.17 -12.92,-0.01 -25.89,0.11 -38.8,-0.02 -2.84,-0.03 -36.36,-0.2 -38.56,0.17z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.279f1401.svg";
export { ForwardRef as ReactComponent };